import { useState, useLayoutEffect } from "react";
import "./style.scss";
import Hero from "../../components/Home/HeroSection/Hero";
import Features from "../../components/Home/Features/Features";
import ActualFeatures from "../../components/Home/ActualFeatures/ActualFeatures";
import Plans from "../../components/Home/Plans/Plans";
import Footer from "../../components/Home/Footer/Footer";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import ContactModal from "../../components/ContactModal/ContactModal";

export default function Home() {
  const [isVideoReady, setIsVideoReady] = useState(false);
  const [showLoading, setShowLoading] = useState(true);
  const [isContactOpen, setIsContactOpen] = useState(false);

  const openContact = () => setIsContactOpen(true);
  const closeContact = () => {
    setIsContactOpen(false);
  };

  // Prevent scrolling when loading screen is visible
  useLayoutEffect(() => {
    if (!showLoading) return;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [showLoading]);

  const handleVideoReady = () => {
    setIsVideoReady(true);
  };

  const handleLoadComplete = () => {
    setShowLoading(false);
  };

  return (
    <>
      {showLoading && (
        <LoadingScreen
          onLoadComplete={handleLoadComplete}
          assetsLoaded={isVideoReady}
        />
      )}
      <Hero onVideoReady={handleVideoReady} onContact={openContact} />
      <Features />
      <ActualFeatures />
      <Plans onContact={openContact} />
      <Footer />
      {!showLoading && (
        <ContactModal
          isOpen={isContactOpen}
          onClose={closeContact}
        />
      )}
    </>
  );
}
